
declare var window:any


const Backbone = require('backbone')

const Produto = Backbone.Model.extend({

})

window.Produto = Produto

const Produtos = Backbone.Collection.extend({
    model: Produto
})

window.Produtos = Produtos



export {
    Produto,
    Produtos
}